import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Row,
  Col,
  CardTitle,
  CardSubtitle,
  CardText,
  Badge,
  Alert,
  Spinner,
} from "reactstrap";
import CategoryServices from "../../../services/OrderingServices/CategoryService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const CategoryDetail = () => {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategoryDetail = async () => {
      setLoading(true);
      try {
        const response = await CategoryServices.viewcategory(id);
        setCategory(response);
        setError(null);
      } catch (err) {
        console.error("Error fetching category details:", err);
        setError("Failed to load category details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner color="primary" />
        <p className="mt-2">Loading category details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert color="danger" className="my-4">
        <h5 className="alert-heading">Error!</h5>
        <p className="mb-0">{error}</p>
      </Alert>
    );
  }

  if (!category) {
    return (
      <Alert color="warning" className="my-4">
        <h5 className="alert-heading">Category Not Found</h5>
        <p className="mb-0">
          The requested category could not be found or may have been removed.
        </p>
      </Alert>
    );
  }

  const breadcrumbItems = [{ title: "Back To List", link: "/category-list" }];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Categories"
          title="Category Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Row>
        {/* Category Image Column - Only show if imageUrl exists */}
        {category.imageUrl && (
          <Col lg={6}>
            <Card className="border-0 shadow">
              <div className="position-relative">
                <img
                  // src={`${window.APP_CONFIG.api1.baseapiV2}/${category.imageUrl}`}
                  src={category.displayImage.getCDNUrl()}
                  alt={category.name}
                  className="img-fluid rounded"
                  style={{ width: "100%", height: "400px", objectFit: "cover" }}
                  onError={(e) => {
                    if (!e.target.dataset.error) {
                      e.target.dataset.error = "true";
                      e.target.src = "/default-category.jpg";
                    }
                  }}
                />
              </div>
            </Card>
          </Col>
        )}

        {/* Category Details Column */}
        <Col lg={category.imageUrl ? 6 : 12}>
          {" "}
          {/* Adjust column width based on image presence */}
          <Card className="border-0 shadow">
            <CardBody>
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <CardTitle tag="h2" className="mb-1 text-primary">
                    {category.name}
                  </CardTitle>
                  <CardSubtitle tag="h6" className="text-muted mb-0">
                    Parent Category:{" "}
                    <span className="fw-bold">
                      {category.parentName || "None"}
                    </span>
                  </CardSubtitle>
                </div>
                <Badge
                  color={category.isActive ? "success" : "danger"}
                  pill
                  className="px-3 py-2 fs-6"
                >
                  {category.isActive ? "Active" : "Inactive"}
                </Badge>
              </div>

              <div className="mb-4 bg-light p-3 rounded">
                <h5 className="border-bottom pb-2 mb-3">Description</h5>
                <CardText>
                  {category.description || "No description available."}
                </CardText>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CategoryDetail;
